/**
 * Library page total for the "N files · M pages" card meta line.
 *
 * DECISION: only report a total when EVERY document carries a numeric
 * ``page_count``. A partial sum would understate the library and read
 * as a real number, so an unknown count returns ``null`` and the UI
 * omits the pages part instead of guessing.
 */

import type { DocumentInfo } from "../../types";

export function totalPageCount(
  documents: readonly Pick<DocumentInfo, "page_count">[] | null | undefined,
): number | null {
  if (!documents || documents.length === 0) return null;
  let total = 0;
  for (const doc of documents) {
    if (typeof doc.page_count !== "number" || !Number.isFinite(doc.page_count) || doc.page_count < 0) return null;
    total += doc.page_count;
  }
  return total;
}
